import { inject, Injectable, signal } from '@angular/core';
import { GroupsDataService } from '@app/shared/services/groups-data.service';
import { CooperationGroup } from '@app/shared/types/models/cooperation/cooperation-group.model';
import { CooperationGroupDTO } from '../dtos/cooperation/cooperation-group.dto';
import { AbstractFactory } from './abstract.factory';

@Injectable({ providedIn: 'root' })
export class CooperationGroupFactory extends AbstractFactory<CooperationGroupDTO, CooperationGroup> {
  private readonly groupsDataService = inject(GroupsDataService);

  public produce(item: CooperationGroupDTO): CooperationGroup {
    if (item.group) {
      this.groupsDataService.upsertLocalData(item.group);
    }
    return new CooperationGroup({
      id: item.id,
      cooperationId: item.cooperationId,
      group: item.group ? this.groupsDataService.getById(item.group.id) : signal(undefined)
    });
  }
}
